import { getValidatedToken } from '@frameio/assets/fields/utils/colorMapping';
import type { SelectOption } from '@frameio/graphql-client/generated';
import { Box, Chip } from '@frameio/vapor';

type MultiSelectFieldMatchProps = {
  option: SelectOption;
  maxTokenCount?: number;
};

export const SelectFieldMatch = ({ option }: MultiSelectFieldMatchProps) => {
  return (
    <Box alignItems="center" display="flex" gap={4} height="100%" paddingY={2}>
      <Chip
        key={option?.displayName}
        color={getValidatedToken(option?.color ?? '')}
        size="small"
      >
        {option?.displayName}
      </Chip>
    </Box>
  );
};
